if(typeof Modernizr === 'undefined') {var e = new Error("Cannot find module \"Modernizr\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = Modernizr;


//////////////////
// WEBPACK FOOTER
// external "Modernizr"
// module id = 386
// module chunks = 2 3